import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { SettingsHelperService } from '../services/settings-helper.service';

@Injectable({
  providedIn: 'root',
})
export class SettingsResolver implements Resolve<any> {
  constructor(
    private helper: SettingsHelperService,
  ) {}

  resolve(): Observable<any> {
    return this.helper.getApplicationSetting();
  }
}
